/** The alert list (an RTS's event notices): bottom right over the map, a
 *  row a kind of trouble, its icon, its count and what it is in words; a
 *  click goes to the next case. Nothing pops up and nothing sounds: it's
 *  there to be glanced at. */

import { For, Show, type JSX } from "solid-js";
import { render } from "solid-js/web";
import { alerts, cycleAlert } from "../state/alerts";
import { GoodIcon } from "./RecipePicker";
import { UNLINKED_SVG } from "../ui/goodIcons";

/** The alerts' own icons, where no good says it. */
const OWN: Record<string, string> = {
  raid: `<svg width="26" height="26" viewBox="0 0 24 24"><path d="M12 2 L14 9 L21 7 L16 12 L21 17 L14 15 L12 22 L10 15 L3 17 L8 12 L3 7 L10 9 Z" fill="#8a93a3" stroke="#0d0d0d" stroke-width="1"/><path d="M15 19 L21 13" stroke="#e0624a" stroke-width="2.4" stroke-linecap="round"/><path d="M21 13 L21 17.5 M21 13 L16.5 13" stroke="#e0624a" stroke-width="2.4" stroke-linecap="round"/></svg>`,
  command: `<svg width="26" height="26" viewBox="0 0 24 24"><path d="M12 3 L12 21 M7 21 L17 21" stroke="#c9c4b8" stroke-width="2"/><path d="M12 4 L20 7 L12 10 Z" fill="#c9c4b8"/><path d="M4 4 L20 20" stroke="#e0624a" stroke-width="2.6" stroke-linecap="round"/></svg>`,
  unlinked: UNLINKED_SVG(26),
  Engineers: `<svg width="26" height="26" viewBox="0 0 24 24"><rect x="4" y="4" width="14" height="6" fill="#c9c4b8" stroke="#0d0d0d" stroke-width="1"/><rect x="9.5" y="10" width="3.5" height="11" fill="#9a8f7e" stroke="#0d0d0d" stroke-width="1"/></svg>`,
  lost: `<svg width="26" height="26" viewBox="0 0 24 24"><path d="M3 21 L3 11 L8 7 L8 11 L13 7 L13 11 L18 7 L21 9 L21 21 Z" fill="#7a6f66" stroke="#0d0d0d" stroke-width="1.2"/><path d="M6 4 L18 18 M18 4 L6 18" stroke="#e0624a" stroke-width="3" stroke-linecap="round"/></svg>`,
};

function AlertStrip(): JSX.Element {
  return (
    <Show when={alerts().length}>
      <div class="alert-strip" role="toolbar" aria-label="Alerts">
        <For each={alerts()}>
          {(a) => (
            <button class="alert" data-tip={`${a.detail} Click to go to the next.`} onClick={() => cycleAlert(a)}>
              <span class="alert-icon">
                <Show when={OWN[a.icon]} fallback={<GoodIcon good={a.icon} size={22} />}>
                  <span class="good-icon-wrap" innerHTML={OWN[a.icon].replace(/width="26" height="26"/, 'width="22" height="22"')} />
                </Show>
                <Show when={a.at.length > 1}>
                  <span class="alert-n">{a.at.length > 99 ? "99+" : a.at.length}</span>
                </Show>
              </span>
              <span class="alert-label">{a.label}</span>
            </button>
          )}
        </For>
      </div>
    </Show>
  );
}

const host = document.createElement("div");
host.id = "alerts";
document.body.appendChild(host);
render(() => <AlertStrip />, host);
